import { initOneOExperiments } from "./experiments"
import { openStorefrontAnchor } from "./openStorefront"
import { cssSelectorForShops, cssSelectorForData1oShopUrl } from "./helpers"
import { track } from "./helpers"

async function initShopsOnPage() {
  await initOneOExperiments()
  setTimeout(() => {
    let shopCTAs = document.querySelectorAll(cssSelectorForShops())

    for (let anchor of shopCTAs) {
      openStorefrontAnchor(anchor)
    }

    track(window.OneO.shopEnv.checkoutAppBase + "/checkouts/", "page_view")

    for (let anchor of shopCTAs) {
      track(anchor.href, "content_impression")
    }

    for (let element of document.querySelectorAll(
      cssSelectorForData1oShopUrl()
    )) {
      track(element.getAttribute("data-1o-shop-url"), "content_impression")
    }
  }, 200)
}

export function initShopsOnPageListener() {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initShopsOnPage)
  } else {
    initShopsOnPage()
  }
}
